import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm0-7.976a.876.876 0 0 0-.875.876V13a.875.875 0 0 0 1.75 0V7.9A.876.876 0 0 0 12 7.024Z"
      clip-rule="evenodd"
    />
  </svg>
`;
